import { createColumnHelper } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { Badge } from 'reactstrap'
import sortingFns from 'src/helpers/sortingHelpers'
import { Contracts } from 'src/queries'

type TData = Contracts[0]

const columnHelper = createColumnHelper<TData>()

export type Columns = Array<ReturnType<typeof columnHelper.accessor>>

const columnsFn = (statuses: string[]): Columns => ([
  columnHelper.accessor('abbreviation', {
    id: 'abbreviation',
    header: 'Abbreviation',
    cell: (info) => {
      const value = info.getValue()
      const id = info.row.original._id
      const abbr = ['', null, undefined].includes(value) ? '(No Abbreviation)' : value
      if (id !== undefined) {
        return (
          <Link to={`/cat/contracts/${String(id)}`}>{abbr}</Link>
        )
      }
      return value
    }
  }),
  columnHelper.accessor('name', {
    id: 'name',
    header: 'Name'
  }),
  columnHelper.accessor('_status.name', {
    id: 'status',
    header: 'Status',
    sortingFn: sortingFns.sortByArray(statuses),
    cell: (info) => {
      const val = info.getValue()
      const color = info.row.original._status?.color ?? 'light'
      const textColor = color === 'light' ? 'text-dark' : ''
      return (
        <Badge color={color} className={`${textColor} w-100`}>{val}</Badge>
      )
    }
  }),
  columnHelper.accessor('_portfolio_manager.name', {
    header: 'Portfolio Manager'
  }),
  columnHelper.accessor('_program_manager.name', {
    header: 'Program Manager'
  }),
  columnHelper.accessor('position_count', {
    header: 'Open Positions',
    cell: (info) => {
      const value = info.getValue()
      if (value === null || value === undefined || value === 0) {
        return ''
      }
      return `${String(value) ?? ''} Open`
    }
  })
])

export { columnsFn }
